<template>
	<div data-cy="profileMain">
	<v-card>
		<v-toolbar color="rgb(0, 160, 227)" flat>
		<v-icon medium> mdi-view-dashboard </v-icon>
		<v-spacer></v-spacer>
		<v-toolbar-title>{{txt.dashboard}}</v-toolbar-title>

		<v-spacer></v-spacer>

        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
			color="secondary"
          >
            <v-tabs-slider color="rgb(230, 0, 126)"></v-tabs-slider>

			<v-tab key="files"> Files</v-tab>
			<v-tab key="info" data-cy="profileInfoTab"> Personal Info</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

		<v-tabs-items v-model="tab">
		<!-- Files -->
		<v-tab-item key="files">
			<v-card flat>
			<v-card-text>
				<file-list></file-list>
			</v-card-text>
			</v-card>
		</v-tab-item>
		<!-- Files -->
		<v-tab-item key="info">
			<v-card flat>
			<v-card-text>
				<personal-info></personal-info>
			</v-card-text>
			</v-card>
		</v-tab-item>

      </v-tabs-items>
    </v-card>
	</div>
</template>

<script>
import FileList from './FileList.vue'
import PersonalInfo from './PersonalInfo.vue'

export default {
	components: {
		FileList,
		PersonalInfo,
	},
	data() {
		return {
			tab: null,
			txt: {
				dashboard: 'Your Dashboard',
			},
		}
	},
}
</script>

<style scoped>

</style>
